import { apiFetch } from '@/shared/api/client'
import { runKitchenSync } from '@/shared/sync/kitchenSync'

import { isMockApi } from '@/shared/env'

export type SaveDeliveryLine = {
  productName: string
  productionDate: string
  qty: number
}

export type SaveDeliveryRequest = {
  deliveryId: string
  deviceId: string
  storeName: string
  delmanName: string
  lines: SaveDeliveryLine[]
}

export type SaveDeliveryResponse = {
  delivery_id: string
  delivery_code: string
  updated_at: string
}

function useMockApi(): boolean {
  return isMockApi
}

function mockSave(req: SaveDeliveryRequest): SaveDeliveryResponse {
  const hasQty = req.lines.some((line) => line.qty > 0)
  if (!hasQty) {
    throw new Error('Isi minimal 1 produk dengan jumlah lebih dari 0.')
  }
  return {
    delivery_id: `mock-${req.deliveryId}`,
    delivery_code: req.deliveryId,
    updated_at: 'Disimpan',
  }
}

export async function saveDispatchDeliveryDirect(
  req: SaveDeliveryRequest,
): Promise<SaveDeliveryResponse> {
  if (useMockApi()) {
    await new Promise((resolve) => setTimeout(resolve, 300))
    return mockSave(req)
  }

  const delivery = encodeURIComponent(req.deliveryId)
  return apiFetch<SaveDeliveryResponse>(`/kitchen/deliveries/${delivery}/save`, {
    method: 'POST',
    body: JSON.stringify({
      store_name: req.storeName,
      delman_name: req.delmanName,
      lines: req.lines,
    }),
  })
}

export async function saveDispatchDelivery(
  req: SaveDeliveryRequest,
): Promise<SaveDeliveryResponse> {
  return runKitchenSync(
    {
      type: 'dispatch_save',
      label: `Simpan pengiriman ${req.storeName}`,
      payload: req,
    },
    () => saveDispatchDeliveryDirect(req),
    () => mockSave(req),
  )
}
